var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaucet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L80 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0 0 48-18.7 0c-12.7 0-24.9 5.1-33.9 14.1L121.4 256 16 256c-8.8 0-16 7.2-16 16s7.2 16 16 16l112 0c4.2 0 8.3-1.7 11.3-4.7l38.6-38.6c3-3 7.1-4.7 11.3-4.7l69.5 0c4.2 0 8.3 1.7 11.3 4.7l38.6 38.6c3 3 7.1 4.7 11.3 4.7l48 0c61.9 0 112 50.1 112 112c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16c0-26.5-21.5-48-48-48l-60.8 0c-5.7 0-11 3-13.8 8c-13.9 24-39.7 40-69.3 40s-55.5-16.1-69.3-40c-2.9-4.9-8.1-8-13.8-8L16 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l116.1 0c20.2 29 53.8 48 91.9 48s71.7-19 91.9-48l52.1 0c8.8 0 16 7.2 16 16c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48c0-79.5-64.5-144-144-144l-41.4 0-33.9-33.9c-9-9-21.2-14.1-33.9-14.1L240 208l0-48 128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0 0-48z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaucet);
export default __webpack_public_path__ + "static/media/faucet.52a6af3a409e12740bbf7f3e37ec4484.svg";
export { ForwardRef as ReactComponent };